
import { defineComponent, reactive, toRefs, PropType } from "vue";
import { InnerCartonParam } from "@/client/schema";
import { Currency } from "@/generic/components/display";

export type Props = {
  innerCartonParam: InnerCartonParam;
};

export default defineComponent({
  components: {
    Currency,
  },
  props: {
    innerCartonParam: {
      type: Object as PropType<InnerCartonParam>,
      required: true,
    },
  },
  setup() {
    const state = reactive({
      visibleParamPreview: false,
    });

    const handleVisibleParamPreview = () => {
      state.visibleParamPreview = true;
    };

    const handleClose = () => {
      state.visibleParamPreview = false;
    };

    return {
      ...toRefs(state),
      handleVisibleParamPreview,
      handleClose,
    };
  },
});
